// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"4f22f9b9","477":"c8df3911"}[chunkId] + ".chunk.js";
};